import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PasswordRecoveryComponent } from '@components/passwordRecovery/passwordRecovery.component';
import { NotificationFacade } from "@redux/facades/notification.facade";
import { AuthService } from "@services/auth/auth.service";
import { LanguageFacade } from "@redux/facades/language.facade";
import { Images } from "@constants/images";
import { TenantDialogComponent } from "@components/tenat-dialog/tenant-dialog.component";
import {Employee} from "@models/employee";
import {User} from "@models/user";
import {CModules} from "@constants/c-modules";
import {Module} from "@models/module";

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  public lang: string | null = null;
  public title = 'auth.login';
  public userName = '';
  public password = '';
  public typeInput = 'password';
  public showPassword = false;
  public images = Images;
  private CModules = CModules;
  private user: User | null = null;
  private modules: Module[] = [];
  private askUser: number[] = [1, 2];
  // @ts-ignore
  public unsubscribeAuth: Subscription;

  constructor(
    public notificationFacade: NotificationFacade,
    public router: Router,
    public dialog: MatDialog,
    public languageFacade: LanguageFacade,
    public service: AuthService,
    private _Activatedroute: ActivatedRoute
  ) {
    const self = this;
    const _lang = self._Activatedroute.snapshot.paramMap.get('lang');
    self.lang = _lang !== null ? _lang : 'en';
    self.languageFacade.setLanguage(self.lang);
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    if (this.service.isAuthenticated()) {
      const modules: any = JSON.parse(<string>sessionStorage.getItem('modules'));
      this.modules = modules;
      const adminModuleName : number = this.CModules.find(e => e.moduleName == "Admin CMS All")?.moduleID ?? 0;
      if (this.modules !== null && this.modules.find(e => e.moduloID == adminModuleName)) {
        this.router.navigateByUrl('/admin/' + this.lang + '/home');
        // this.openDialogTenant();
      } else {
        this.router.navigateByUrl('/admin/' + this.lang + '/home');
      }
      // this.router.navigateByUrl('/admin/' + this.lang + '/home');
    }
    else {
      this.service.logout();
    }
  }

  public login = () => {
    // this.router.navigateByUrl('admin/es/home');
    this.service.login(this.userName, this.password).then(
        (data: any) => {
          if (data !== false) {
            this.notificationFacade.setSuccess('Se ha iniciado sesion correctamente');
            this.user = data.session.user;
            if (this.askUser.includes(data.session.user.roleGroupID)) {
              this.openDialogTenant();
            } else {
              this.router.navigateByUrl('/admin/' + this.lang + '/home');
            }
          }
        }
    );
  }

  public openDialog = (): void => {
    const dialogRef = this.dialog.open(PasswordRecoveryComponent, {
      width: '500px',
      data: { email: this.userName },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(['The dialog was closed', result]);
    });
  }

  public openDialogTenant = (): void => {
    const dialogRef = this.dialog.open(TenantDialogComponent, {
      width: '500px',
      data: { user: this.user },
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.router.navigateByUrl('/admin/' + this.lang + '/home');
    });
  }
}
